<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!inspectionForm">
      <span class="loader"></span>
    </span>
    <inspection-form-form
      v-if="inspectionForm"
      :loading="loading"
      :inspectionFormData="inspectionForm"
      :formErrors="formErrors"
      @inspectionFormSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import InspectionFormForm from "../partials/InspectionFormForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: { InspectionFormForm },

  mixins: [alertLeave, requestErrorMixin],

  props: {
    inspectionFormId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      inspectionForm: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "inspectionForms/get",
          this.inspectionFormId
        );
        this.inspectionForm =
          this.$store.getters["inspectionForms/inspectionForm"];
        this.loading = false;
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(inspectionForm) {
      this.loading = true;
      const inspectionFormData = cloneDeep(inspectionForm);

      try {
        await this.$store.dispatch(
          "inspectionForms/update",
          inspectionFormData
        );
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("INSPECTION_FORMS.INSPECTION_FORM_UPDATED"),
        });
        const inspectionForm = await this.$store.getters[
          "inspectionForms/inspectionForm"
        ];
        this.$emit("onViewInspectionForm", inspectionForm, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
